// extracted by mini-css-extract-plugin
export default {"paginationWrapper":"styles_paginationWrapper__52EL+"};